import './header.scss';
import './toggle-btn/toggle-btn.scss';
import { ReactComponent as HeaderIcon } from '../assets/header-logo-main.svg';
import { ReactComponent as UniHeaderLogo } from '../assets/uni-header-logo.svg';
import { ReactComponent as HeaderSmallIcon } from '../assets/header-logo-small.svg';
import { ReactComponent as NewConversationBtn } from '../assets/new-conversation-btn.svg';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { allTagsAtom } from '../atoms';
import { useAtom, useSAtom } from 'jotai';
import { TagsDropdown } from './tags/tagsDropdown';

export const Header = ({ isEnglishUi, botName, sessionId }) => {
  const [allTags] = useAtom(allTagsAtom);

  const refreshPage = () => {
    window.location.reload();
  };

  const isSmartPhone = window.matchMedia('(max-width: 600px)').matches;

  return (
    <div
      className="header"
      style={{
        flexDirection: isEnglishUi ? 'row-reverse' : 'row',
        position: isSmartPhone ? '' : 'fixed',
      }}
    >
      {isSmartPhone ? (
        <HeaderSmallIcon style={{ cursor: 'auto' }} />
      ) : (
        <div className="header-icons">
          <HeaderIcon
            style={{ cursor: 'auto' }}
            title="לוגו של המכון למורשת בן גוריון"
            aria-label="לוגו של המכון למורשת בן גוריון"
            role="img"
          />
          <UniHeaderLogo
            style={{ cursor: 'auto', marginTop: '5px' }}
            aria-label="לוגו של אוניברסיטת בן גוריון בנגב"
            title="לוגו של אוניברסיטת בן גוריון בנגב"
            role="img"
          />
        </div>
      )}

      <div className="left-side">
        <button
          className="new-conversation-container"
          onClick={refreshPage}
          alt="שיחה חדשה"
          title="שיחה חדשה"
        >
          {isEnglishUi ? 'New Chat' : ' שיחה חדשה'}
          <NewConversationBtn className="new-conversation-btn" />
        </button>
      </div>
    </div>
  );
};
